import React from 'react'
import { observer } from 'mobx-react'
import JobViewModel, { Tab } from '../JobViewModel'
import { match } from 'utils/pattern-match-util'
import DetailsView from '../DetailsView'
import CommunicationView from '../CommunicationView'
import JobSummaryCard from '../JobSummaryCard'
import JobNotesCard from '../JobNotesCard'
import CollaboratorsCard from '../CollaboratorsCard'
import styles from './ContentView.sass'
import DragAndDropOverlay from '../DragAndDropOverlay'
import TasksCard from '../TasksCard'
import JobProgressionCard from '../JobProgressionCard'
import PaymentDistributionCard from '../PaymentDistributionCard'
import JobTicketsCard from '../JobTicketsCard'
import CompleteOnboardingCard from '../CompleteOnboardingCard'
import JobInsightsCard from '../JobInsightsCard'
import InfoGatheringCard from '../InfoGatheringCard'
import ConsultationCallCard, {
  DownloadCalendarButton,
} from '../ConsultationCallCard'
import RatingsNotificationBar from '../../../../ratings/components/RatingsNotificationBar'
import JobProgressionAndConsultationCard from '../JobProgressionAndConsultationCard'
import BookkeepingProgressionCard from '../BookkeepingProgressionCard'
import BookkeepingTrackerCard from '../BookkeepingTrackerCard'
import RoomCard from '../RoomCard'

interface Props {
  vm: JobViewModel
}

export default observer(function ContentView({ vm }: Props) {
  return (
    <div className={styles.root}>
      <RatingsNotificationBar vm={vm} />
      <DragAndDropOverlay
        vm={vm.documentsVM.uploadBarVM}
        targetJob={vm.job}
        onViewClick={
          vm.currentTab === Tab.Details
            ? undefined
            : () => vm.setTab(Tab.Details)
        }
      />

      <SplitContentView vm={vm} />
    </div>
  )
})

const SplitContentView = observer(function SplitContentView({ vm }: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.leftSide}>
        {match(vm.visibleCard, {
          COMPLETE_ONBOARDING_CARD: () => <CompleteOnboardingCard vm={vm} />,
          INFO_GATHERING_CARD: () => <InfoGatheringCard vm={vm} />,
          JOB_PROGRESSION_CONSULTATION_CARD: () => (
            <JobProgressionAndConsultationCard vm={vm} />
          ),
          CONSULTATION_CALL_CARD: () => <ConsultationCallCard vm={vm} />,
          JOB_PROGRESSION_CARD: () => <JobProgressionCard vm={vm} />,
          TASK_CARD: () => <TasksCard vm={vm} />,
          BOOKKEEPING_CARD: () => (
            <>
              <BookkeepingProgressionCard vm={vm.bookkeepingProgressionVM} />
              <BookkeepingTrackerCard vm={vm.bookkeepingProgressionVM} />
            </>
          ),
        })}

        {vm.showCallCard && (
          <RoomCard
            vm={vm.roomVM}
            buttonGroup={<DownloadCalendarButton vm={vm} />}
          />
        )}

        {vm.canViewJobInsights && <JobInsightsCard vm={vm} />}

        {vm.canViewJobNotes && <JobNotesCard vm={vm} />}

        <CollaboratorsCard vm={vm} />

        <JobTicketsCard vm={vm} />

        <JobSummaryCard vm={vm} />

        {vm.canViewPaymentDistributionAsAdmin && (
          <PaymentDistributionCard vm={vm} />
        )}
      </div>

      <div className={styles.tabs}>
        {match(vm.currentTab, {
          [Tab.Details]: () => <DetailsView vm={vm} />,
          [Tab.Communication]: () =>
            vm.showDraftView ? null : <CommunicationView vm={vm} />,
          [Tab.Milestones]: () => null,
          [Tab.Collaborators]: () => null,
          [Tab.Documents]: () => null,
        })}
      </div>
    </div>
  )
})
